module.exports = __webpack_public_path__ + "static/media/VM3ALogo.a31a0f83.png";